// extracted by mini-css-extract-plugin
export default {"stars":"AppStars_stars__d1spv","animStar":"AppStars_animStar__UPqHU","stars2":"AppStars_stars2__NlkYp","stars3":"AppStars_stars3__N8ajF"};